import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PageTitle from '../../../Layout/Components/PageTitle';
import PhishingIcon from '../../../Layout/Components/PhishingIcon';
import CopyableDeliveryValue from './CopyableDeliveryValue';
import './DeliverySettings.css';
import './Microsoft365Guide.css';

const deliveryPath = '/organization/phishing_simulator/delivery-settings';
const portalURL = 'https://security.microsoft.com/advanceddelivery';
// Technical SMTP values from the e.Veritas Microsoft 365 setup guide.
const sendingDomain = 'phish-simulator.com';
const sendingIP = '154.12.245.33';
const screenshots = { 2: 'advanced-delivery', 3: 'sending-fields', 4: 'sending-details', 6: 'saved-entries' };
const steps = [1, 2, 3, 4, 5, 6, 7];

export function Microsoft365GuideContent({ t }) {
  const text = key => t(`microsoft365_guide.${key}`);
  return <div className="m365-guide">
    <aside className="m365-guide__before"><strong>{text('before_title')}</strong> {text('before_body')}</aside>
    <div className="m365-guide__layout">
      <nav className="m365-guide__navigation" aria-label={text('steps_label')}>
        <strong>{text('steps_label')}</strong>
        <ol>{steps.map(step => <li key={step}><a href={`#m365-step-${step}`}><span aria-hidden="true">{step}</span>{text(`step${step}_title`)}</a></li>)}</ol>
        <p>{text('ownership_note')} <Link to={deliveryPath}>{text('back')}</Link></p>
      </nav>
      <div className="m365-guide__content">
        {steps.map(step => <section key={step} id={`m365-step-${step}`} className="m365-guide__step" aria-labelledby={`m365-heading-${step}`}>
          <h2 id={`m365-heading-${step}`}><span aria-hidden="true">{step}</span>{text(`step${step}_title`)}</h2>
          <p>{text(`step${step}_body`)}</p>
          {step === 1 && <a className="btn btn-primary" href={portalURL} target="_blank" rel="noopener noreferrer">{text('open_portal')} <span aria-hidden="true">↗</span></a>}
          {step === 4 && <>
            <div className="m365-guide__values authenticated-domains">
              <CopyableDeliveryValue label="Domain" value={sendingDomain} t={t} />
              <CopyableDeliveryValue label="Sending IP" value={sendingIP} t={t} />
            </div>
            <p className="m365-guide__note">{text('domain_note')}</p>
            <p className="m365-guide__note">{text('urls_note')}</p>
          </>}
          {screenshots[step] && <figure>
            <a href={`/images/guides/microsoft-365/${screenshots[step]}.png`} target="_blank" rel="noopener noreferrer" aria-label={text(`image${step}_zoom`)}>
              <img src={`/images/guides/microsoft-365/${screenshots[step]}.png`} alt={text(`image${step}_alt`)} loading="lazy" />
            </a>
            <figcaption>{text(`image${step}_caption`)}</figcaption>
          </figure>}
          {step === 7 && <><p>{text('tracking_test')}</p><Link className="btn btn-outline-primary" to="/organization/phishing_simulator/smtpconfig">{text('open_profiles')}</Link></>}
        </section>)}
        <footer className="m365-guide__footer">
          <p>{text('screenshots_note')}</p>
          <a href="https://learn.microsoft.com/en-us/defender-office-365/advanced-delivery-policy-configure" target="_blank" rel="noopener noreferrer">{text('reference')} ↗</a>
        </footer>
      </div>
    </div>
  </div>;
}

function Microsoft365Guide({ t }) {
  return <><PageTitle heading={t('microsoft365_guide.title')} subheading={t('microsoft365_guide.subtitle')} icon={<PhishingIcon name="delivery" />}
    actions={<Link className="btn btn-outline-primary" to={deliveryPath}>← {t('microsoft365_guide.back')}</Link>} />
    <Microsoft365GuideContent t={t} /></>;
}

export default withTranslation()(Microsoft365Guide);
